import { type Match } from '@common/clients/api';
import { MatchBlockWrapper } from '@web/templates/CustomPage/atoms/MatchBlockWrapper';

import styles from './MatchBlockContainer.module.scss';

export const MatchBlockContainer = ({ matches }: { matches: Match[] }) => {
    return (
        <div className={styles.container} data-testid="match-block">
            {matches.map((match: Match) => (
                <MatchBlockWrapper key={match.id} matchID={match.id} />
            ))}
        </div>
    );
};
